import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Alert, Button } from "antd";

export default class Landing extends Component {
  render() {
    return (
      <div className="landing-container data-container h-100">
        <div className="landing-card-wrapper">
          <div
            className="landing-card"
            style={{ width: "200px", fontWeight: "700" }}
          >
            Select Laptop Category
          </div>
          <div className="arrows">
            <div id="arrowAnim">
              <div className="arrowSliding">
                <div className="arrow" />
              </div>
              <div className="arrowSliding delay1">
                <div className="arrow" />
              </div>
              <div className="arrowSliding delay2">
                <div className="arrow" />
              </div>
              <div className="arrowSliding delay3">
                <div className="arrow" />
              </div>
            </div>
          </div>
          <div
            className="landing-card"
            style={{ width: "200px", fontWeight: "700" }}
          >
            Select BOM type
          </div>
          <div className="arrows">
            <div id="arrowAnim">
              <div className="arrowSliding">
                <div className="arrow" />
              </div>
              <div className="arrowSliding delay1">
                <div className="arrow" />
              </div>
              <div className="arrowSliding delay2">
                <div className="arrow" />
              </div>
              <div className="arrowSliding delay3">
                <div className="arrow" />
              </div>
            </div>
          </div>
          <div
            className="landing-card"
            style={{ width: "200px", fontWeight: "700" }}
          >
            Finalize the BOM
          </div>
        </div>
        <Button
          size="large"
          form="buildForm"
          key="submit"
          htmlType="submit"
          type="primary"
        >
          <Link to="/build">Get Started</Link>
        </Button>
      </div>
    );
  }
}
